import { render, staticRenderFns } from "./SelecionarLaudo.vue?vue&type=template&id=1f8468c0&scoped=true&lang=pug"
import script from "./SelecionarLaudo.vue?vue&type=script&lang=js"
export * from "./SelecionarLaudo.vue?vue&type=script&lang=js"
import style0 from "./SelecionarLaudo.vue?vue&type=style&index=0&id=1f8468c0&prod&scoped=true&lang=scss"
import style1 from "./SelecionarLaudo.vue?vue&type=style&index=1&id=1f8468c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8468c0",
  null
  
)

export default component.exports